<template>
  <div>
    <Nav />
    <img src="../assets/images/bs.png" style="width: 100%" fit="cover" alt="" />
    <div class="imgBox">
      <img class="bs-Img" src="../assets/images/1.png" alt="" />
      <img class="bs-Img" src="../assets/images/2.png" alt="" />
      <img class="bs-Img" src="../assets/images/3.png" alt="" />
      <img class="bs-Img" src="../assets/images/4.png" alt="" />
      <img class="bs-Img" src="../assets/images/5.png" alt="" />
      <img class="bs-Img" src="../assets/images/6.png" alt="" />
      <img class="bs-Img" src="../assets/images/7.png" alt="" />
      <img class="bs-Img" src="../assets/images/8.png" alt="" />
    </div>
    <div class="bg-container">
      <div class="form-container">
        <div class="business-title">
          <el-tabs v-model="activeName" v-if="isPC">
            <el-tab-pane name="first">
              <template #label>
                <span class="cTitle">在线留言</span>
                <span class="eTitle">Online Message</span>
              </template>
            </el-tab-pane>
          </el-tabs>
          <span class="text" v-else>品牌加盟</span>
        </div>
        <el-form class="form" :model="form" :rules="rules" ref="form" :label-position="labelPosition" label-width="110px">
          <el-form-item label="电   话" prop="tel" style="white-space: pre" label-width="80px">
            <el-input v-model="form.tel"></el-input>
          </el-form-item>
          <el-form-item label="传   真" prop="fax" style="white-space: pre">
            <el-input v-model="form.fax"></el-input>
          </el-form-item>
          <el-form-item label="邮   箱" prop="email" style="white-space: pre" label-width="80px">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-input v-model="form.code" auto-complete="off" style="width: 65%" @keyup.enter.native="handleLogin"></el-input>
            <div class="login-code">
              <img :src="codeUrl" @click="getCode" class="login-code-img" />
            </div>
          </el-form-item>
          <div class="solid" v-if="isPC"></div>
          <el-form-item label="留言内容" prop="content" :label-position="top">
            <el-input :rows="4" type="textarea" v-model="form.content"></el-input>
          </el-form-item>
        </el-form>
        <div class="submit">
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
        </div>
      </div>
    </div>
    <Footer v-if="isPC" class="top" />
    <PhFooter v-else></PhFooter>
  </div>
</template>

<script>
import { addBusiness, getCaptchaImage } from '@/api/index.js'

export default {
  name: 'Business',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      labelPosition: 'right', // 默认设置为 "top"
      codeUrl: '',
      form: {
        name: '',
        code: '',
        uuid: ''
      },
      rules: {
        content: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ]
      },
      activeName: 'first',
      outerWidth: window.innerWidth // 屏幕宽度
    }
  },
  computed: {
    isPC() {
      return this.outerWidth > 768
    }
  },
  created() {
    this.getCode()
  },
  mounted() {
    // 在页面加载时检查屏幕宽度
    this.updateLabelPosition()
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateLabelPosition)
  },
  beforeDestroy() {
    // 移除事件监听器，避免内存泄漏
    window.removeEventListener('resize', this.updateLabelPosition)
  },
  methods: {
    // 获取验证码
    getCode(event) {
      getCaptchaImage().then((res) => {
        this.codeUrl = 'data:image/gif;base64,' + res.data.img
        this.form.uuid = res.data.uuid
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addBusiness(this.form)
            .then((response) => {
              // console.log('API请求成功:', response)
              this.$message.success('申请提交成功')
              this.resetForm(formName)
              this.getCode()
            })
            .catch((error) => {
              console.error('API请求失败:', error)
              this.getCode()
              // this.$message.error('申请提交失败')
            })
        } else {
          console.log('表单验证失败')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    updateLabelPosition() {
      // 根据屏幕宽度设置 label-position
      this.outerWidth = window.innerWidth
      this.labelPosition = window.innerWidth < 768 ? 'top' : 'right'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__item {
  margin-bottom: 12px;
}

::v-deep .el-tabs__active-bar {
  width: 60px !important;
  height: 4px;
}
::v-deep .el-form-item__label {
  font-size: 20px;
  color: #000000;
  line-height: 33px;
  font-family: PingFangSC, PingFang SC;
}
.bs-Img {
  width: 100%;
  object-fit: cover;
}
.bg-container {
  font-family: PingFangSC, PingFang SC;
  background: #fff;
  display: flex;
  justify-content: center;
  width: 100%;
  flex: 1; // Allow the container to grow and fill available space
}
.business-title {
  padding: 72px 0 0 0;
  width: 1200px;
  .cTitle {
    font-weight: 600;
    font-size: 30px;
    color: #000000;
    line-height: 42px;
    margin-right: 15px;
  }
  .eTitle {
    font-size: 24px;
    color: #000000;
    line-height: 33px;
  }
}

.form-container {
  width: 1200px; // 设置表单容器的最大宽度
  margin: 0 auto; // 将表单容器居中对齐
}
.form {
  display: flex;
  flex-wrap: wrap;
  margin-top: 35px;
  .solid {
    margin-top: 50px;
    width: 1200px;
    height: 1px;
    border: 1px dashed rgba(0, 0, 0, 0.2);
  }
  .el-form-item:last-child {
    width: 100%; /* 让第一项宽度为 100% */
    margin-top: 44px;
  }

  .el-form-item:not(:last-child) {
    width: 50%; /* 其余项宽度为 50% */
  }
  .login-code {
    width: 33%;
    height: 40px;
    float: right;
    img {
      width: 160px;
      height: 40px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
}
.submit {
  width: 100%;
  text-align: center;
  margin: 50px 0 115px 0;
  button {
    width: 458px;
    height: 48px;
    border-radius: 24px;
  }
}

@media (max-width: 768px) {
  ::v-deep .el-form-item__label {
    font-size: 13px;
    color: #333;
    line-height: 16px;
  }
  .bg-container {
    margin: 16px 0;
    background: none;
  }
  .form-container {
    width: 348px; // 设置表单容器的最大宽度
    margin: 0 auto; // 将表单容器居中对齐
    background: #fff;
  }
  .business-title {
    margin: 14px 0 22px;
    padding: 0;
    width: 100%;
    text-align: center;
  }

  .text {
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    margin: auto;
    font-weight: bold;
  }

  .form {
    width: 321px;
    display: unset; /* 或者 initial */
    .el-form-item:last-child {
      width: 321px; /* 让第一项宽度为 100% */
      margin: 0 auto 15px;
    }

    .el-form-item:not(:last-child) {
      margin: auto;
      margin-bottom: 15px;
      width: 321px; /* 其余项宽度为 50% */
    }
    .el-form-item {
      margin-bottom: 15px;
    }

    .login-code {
      width: 33%;
      float: right;
      img {
        width: 100%;
        height: 40px;
        cursor: pointer;
        vertical-align: middle;
        object-fit: cover;
      }
    }
  }
  .submit {
    width: 100%;
    text-align: center;
    margin: 9px 0 13px 0;
    button {
      width: 321px;
      height: 40px;
      border-radius: 5px;
    }
  }
}
</style>
<style lang="scss">
#app {
  background: rgba(170, 212, 250, 0.1);
}
</style>
